export default __webpack_public_path__ + "static/media/plat-ben2.a8e41d7b.svg";